import { useDocumentsForTemplate } from 'hooks/useDocumentsForTemplate'
import React, { useState } from 'react'
import { ListGroup } from 'react-bootstrap'
import { Document, TemplateDocument } from 'types'
import { ActiveDocument } from '../ProjectTemplateDisplay'
import { DownloadDocumentsButton } from 'components/DownloadDocumentsButton'
import { DocumentSelectionCheckbox } from 'components/DocumentSelectionCheckbox'
import { LoadMoreButton } from 'components/LoadMoreButton'
import { styles } from './styles'
import { useAppContext } from 'state/context'
import { shouldProvideLoadMore } from 'utils/loadMoreHelpers'
import { nextPageNumber } from 'utils/loadMoreHelpers'
import { fetchDocuments } from 'state/async_actions'

interface DisplayProps {
  activeDocument: ActiveDocument
  templateDocument: TemplateDocument
  setActiveDocument: React.Dispatch<ActiveDocument>
  permissionsList?: any
}
interface CheckedDocuments {
  [id: number]: boolean
}

export const templateLinkText = (title: string) => `${title} (Original)`
export enum Checked {
  False = 0,
  True = 1,
}

export const DocumentListDisplay = ({
  activeDocument,
  templateDocument,
  setActiveDocument,
  permissionsList
}: DisplayProps) => {
  const documents = useDocumentsForTemplate(templateDocument.id)
  const [checkedDocuments, setCheckedDocuments] = useState<CheckedDocuments>({})

  const checked = (document: Document) =>
    checkedDocuments[document.id] ? Checked.True : Checked.False

  const toggleCheckbox = (document: Document) => () => {
    const checkboxState = checkedDocuments[document.id]
    setCheckedDocuments({ ...checkedDocuments, [document.id]: !checkboxState })
  }

  const isActive = (currentDocument: Document | TemplateDocument) =>
    activeDocument && currentDocument.id === activeDocument.id

  const onSelectView = (document: ActiveDocument) => () => {
    setActiveDocument(document)
  }

  const documentIds = Object.keys(checkedDocuments)
    .map(Number)
    .filter(id => checkedDocuments[id])

  const [, dispatch] = useAppContext()
  const loadMore = () => {
    const nextPage = nextPageNumber(documents)

    fetchDocuments(dispatch, templateDocument.id, nextPage)
  }
console.log("docs", documents, permissionsList);

  return (
    <>
      <ListGroup as="ul" style={styles.documentSelector}>
        <ListGroup.Item
          active={isActive(templateDocument)}
          as="li"
          key={templateDocument.id}
          onClick={onSelectView(templateDocument)}>
          {templateLinkText(templateDocument.title)}
        </ListGroup.Item>

        {documents.map((document:any) => (
          <div key={document.id} style={styles.flexContainer}>
            {((document?.permissions?.isOwner && permissionsList?.document?.download_self_created) || (!document?.permissions?.isOwner && permissionsList?.document?.download_created_by_other)) && <DocumentSelectionCheckbox
              checked={checked(document)}
              toggleCheckbox={toggleCheckbox(document)}
            />}
            <ListGroup.Item
              active={isActive(document)}
              as="li"
              onClick={onSelectView(document)}>
              {document.title}
            </ListGroup.Item>
          </div>
        ))}
        {shouldProvideLoadMore(documents) ? (
          <LoadMoreButton onClick={loadMore} />
        ) : null}
      </ListGroup>
      <DownloadDocumentsButton documentIds={documentIds} />
    </>
  )
}
